import { get, post } from '../../../services/request';

// Fetch Capacity Table Reports with Pagination
export const fetchCapacityTableReportsService = (payload) => {
    return post('CapacityTable/GetCapacityTableReportsWithPaginationEncore', payload);
};

// Notes Edit Service (Encore report note)
export const fetchCapacityNotesEditService = (payload) => {
    return get(`CapacityTable/GetCapacityReportNoteEncore?CapacityTableID=${payload.CapacityTableID}`);
};

// Notes Save Service (Encore report note)
export const fetchCapacityNotesSaveService = (payload) => {
    return post('CapacityTable/UpdateCapacityReportNoteEncore', {
        CapacityTableID: payload.CapacityTableID,
        Notes: payload.Notes,
    });
};

// Delete Capacity Report Service (Encore draft)
export const deleteCapacityReportService = (payload) => {
    return post('CapacityTable/DeleteCapacityTableReportEncore', { CapacityTableID: payload.CapacityTableID });
};

// Enable Coverage Gap Capacity Table Report Service (Encore)
export const enableDisableCapacityTableReportService = (payload) => {
    return post('CapacityTable/EnableCoverageGapCapacityTableReportEncore', payload);
};

// Get Active Coverage Gap Capacity Table Report Service (Encore) -- looked up right before
// showing the enable confirmation, since the reports list is server-paginated and the
// currently-active report may not be on the loaded page.
export const getActiveCoverageGapCapacityTableReportService = () => {
    return get('CapacityTable/GetActiveCoverageGapCapacityTableReportEncore');
};


// CoverageGapTool Data Refresh Service
export const coverageGapToolDataRefreshService = () => {
    return get('CoverageGapTool/CoverageGapToolDataRefresh');
};

// CoverageGapTool Child Data Refresh Service
export const coverageGapToolChildDataRefreshService = () => {
    return get('CoverageGapTool/CoverageGapToolChildDataRefresh');
};

// Get Rad Shift Paste Input All Dropdown List Service
// Get Shift Paste Input Filter Data With Pagination Service
export const getShiftPasteInputFilterDataWithPaginationService = (payload = {}) => {
    return post('CapacityTable/GetSchedulesEncoreWithPagination', payload);
};

export const getShiftPasteInputRefreshDataWithPaginationService = (payload) => {
    return post('CapacityTable/GetShiftPasteInputRefreshDataWithPagination', payload);
};

export const publishCapacityTableReportService = (payload) => {
    return post('CapacityTable/PublishCapacityTableEncore', payload);
};

// Get All Capacity Table Published Report List for Dropdown
export const getAllCapacityTablePublishedReportListService = () => {
    return get('CapacityTable/GetAllCapacityTablePublishedReportListEncore');
};

// Get Capacity Table Report Service (Encore: creates the draft entirely on _Encore tables)
export const getCapacityTableReportService = (payload) => {
    return get(`CapacityTable/GetCapacityTableReportEncore?DemandTableID=${payload.DemandTableID}`);
};

// Get Capacity Table Dropdowns Service (pure-read, no draft created -- used by View Mode,
// where GetCapacityTableReportEncore can't be reused since it always creates a new draft)
export const getCapacityTableDropdownsEncoreService = () => {
    return get('CapacityTable/GetCapacityTableDropdownsEncore');
};

// Fetch Demand Table Data With Pagination Service (used by Capacity Table's Demand Table tab)
export const fetchCapacityDemandTableService = (payload) => {
    return post('CapacityTable/GetCapacityDemandTableDemandWithPaginationEncore', payload);
};

// Get Demand Input Filter Dropdown List (Worklist Group / Day of Week options for the
// Capacity Table page's Demand Table tab filter panel)
export const getCapacityDemandInputFilterDDListService = (payload) => {
    return get(`DemandTable/GetDemandInputFilterDDList?ReportId=${payload.ReportId}&DemandTableId=${payload.DemandTableId}`);
};

// Get Worklist By Worklist Group Dropdown List (cascading Worklist filter)
export const getCapacityWorklistByWorklistGroupDDListService = (worklistGroupIds) => {
    return get(`DemandTable/GetWorklistByWorklistGroupDropDown?worklistGroupIds=${worklistGroupIds}`);
};

// Get Active/Pending/Offboarding Radiologist Data By ID Services (Encore) -- sourced from
// the Encore ActiveRad/PendingRad/OffBoardingRad snapshot tables (same as the CSV export),
// not the legacy GetCapacityTableById, which reads pre-Encore tables an Encore-created
// draft never populates.
export const getActiveRadDataByIdService = (payload) => {
    return get(`CapacityTable/GetRadTransitionEncore?CapacityTableID=${payload.CapacityTableID}&tab=active`);
};

export const getPendingRadDataByIdService = (payload) => {
    return get(`CapacityTable/GetRadTransitionEncore?CapacityTableID=${payload.CapacityTableID}&tab=pending`);
};

export const getOffboardingRadDataByIdService = (payload) => {
    return get(`CapacityTable/GetRadTransitionEncore?CapacityTableID=${payload.CapacityTableID}&tab=offboarding`);
};

export const saveIsExcludedService = (payload) => {
    return post('ShiftInputDetails/SaveIsExcluded', payload);
};

// Unlink Schedule Encore Service
export const unlinkScheduleEncoreService = (payload) => {
    return post('CapacityTable/UnlinkScheduleEncore', payload);
};

// Relink Schedule Encore Service
export const relinkScheduleEncoreService = (payload) => {
    return post('CapacityTable/RelinkScheduleEncore', payload);
};

// Refresh Schedules Encore Service
export const refreshSchedulesEncoreService = (payload) => {
    return post('CapacityTable/RefreshSchedulesEncore', payload);
};

// Get Duplicate Schedule Data Service
export const getDuplicateScheduleDataService = (payload) => {
    return post('CapacityTable/GetDuplicateShiftPasteInputDataWithPagination', payload);
};

// Delete Duplicate Shift Paste Input Data Service
export const deleteDuplicateShiftPasteInputDataService = (payload) => {
    return post('CapacityTable/DeleteDuplicateShiftPasteInputData', payload);
};

// Save Radiologist Shift Input Details Service
export const saveRadiologistShiftInputDetailsService = (payload) => {
    return post('ShiftInputDetails/SaveRadiologistShiftInputDetails', payload);
};

// Provider Request (RadRequest) - Get With Pagination
// NOTE: @CurrentPage is the OFFSET (skip) value on the SP, so pass (page-1)*perPage.
export const fetchRadRequestsWithPaginationService = (payload) => {
    return post('RadRequest/GetRadRequestsWithPagination', payload);
};

// Provider Request (RadRequest) - Change Status (Mode: 1 Approve / 2 Simulate / 3 Reject)
export const changeRequestStatusService = (payload) => {
    return post('RadRequest/ChangeRequestStatus', payload);
};

export const scheduleRequestTransactionService = (payload) => {
    return post('RadRequest/ScheduleRequestTransaction', payload);
};

// Capacity Grid (Encore) - 12-week rolling forecast, Live only
export const getCapacityGridEncoreService = (payload) => {
    return post('CapacityTable/GetCapacityGridEncoreWithPagination', payload);
};

// Simulator (Encore) - net = capacity - demand, Live/Simulated rows
export const getSimulatorEncoreService = (payload) => {
    return post('CapacityTable/GetSimulatorEncoreWithPagination', payload);
};

// Simulator dropdowns (Encore)
export const getSimulatorEncoreDropdownsService = (payload) => {
    return get(`CapacityTable/GetSimulatorEncoreDropdowns?CapacityTableID=${payload.CapacityTableID}`);
};

// Access to Demand (Encore) - Simulator hour-cell modal
export const getAccessToDemandEncoreService = (payload) => {
    return post('CapacityTable/GetAccessToDemandEncore', payload);
};

// Exports (Encore)
export const exportCapacityGridEncoreService = (payload) => {
    return get(`CapacityTable/ExportCapacityGridEncore?CapacityTableID=${payload.CapacityTableID}`);
};

export const exportRadTransitionEncoreService = (payload) => {
    return get(`CapacityTable/ExportRadTransitionEncore?CapacityTableID=${payload.CapacityTableID}&tab=${payload.tab || 'active'}`);
};

// Provider Request (RadRequest) - Find Shift Conflicts for a provider/window
export const findShiftConflictsService = (payload) => {
    return post('RadRequest/FindShiftConflicts', payload);
};

export const assignRequestTaskService = (payload) => {
    return post('RadRequest/AssignRequestTask', payload);
};

// Delete Shift Input Details Service
export const deleteShiftInputDetailService = (payload) => {
    return post('CapacityTable/DeleteScheduleEncore', payload);
};

// Get Shift Input Details By ID Service
export const getShiftInputDetailsByIdService = (shiftInputDetailID) => {
    return get(`ShiftInputDetails/GetRadiologistShiftInputDetailsByID?ShiftInputDetailID=${shiftInputDetailID}`);
};

// Get Simulator RPCE With Pagination Service
export const getSimulatorRPCEWithPaginationService = (payload) => {
    return post('CapacityTable/GetSimulatorRPCEWithPagination', payload);
};

// Get Capacity Table Grid Data With Pagination Service
export const getCapacityTableGridDataWithPaginationService = (payload) => {
    return post('CapacityTable/GetCapacityTableGridDataWithPagination', payload);
};

// Update Radiologist Shift Input Details Service
export const updateRadiologistShiftInputDetailsService = (payload) => {
    return post('ShiftInputDetails/UpdateRadiologistShiftInputDetails', payload);
};

// Draft Capacity Table Report Service
export const draftCapacityTableReportService = (payload) => {
    return post('CapacityTable/DraftCapacityTableReportEncore', payload);
};

// Shift Paste Input Duplicate Check Service
export const shiftPasteInputDuplicateCheckService = (payload) => {
    return get(`CapacityTable/ShiftPasteInputDuplicateCheck?DemandTableID=${payload.DemandTableID}`);
};

// Get Capacity Table Refresh Data Service
export const getCapacityTableRefreshDataService = (payload) => {
    return post('CapacityTable/GetCapacityTableRefreshData', payload);
};

// Get Simulator Worklist With Pagination Service
export const getSimulatorWorklistWithPaginationService = (payload) => {
    return post('CapacityTable/GetAvailableShiftsSimulatorWithPagination', payload);
};

// Get Capacity RPCE Details Service
export const getCapacityRPCEDetailsService = (payload) => {
    return post('CapacityTable/GetCapacityRPCEDetails', payload);
};

// Get Capacity worklist Details Service
export const getCapacityDetailsService = (payload) => {
    return post('CapacityTable/GetCapacityDetails', payload);
};

// Get All Emulator Data Service (for simulator refresh - worklist)
export const getAllEmulatorDataService = (payload) => {
    return post('CapacityTable/GetAllEmulatorData', payload);
};

// Get All Emulator RPCE Data Service (for simulator refresh - RPCE)
export const getAllEmulatorRPCEDataService = (payload) => {
    return post('CapacityTable/GetAllEmulatorRPCEData', payload);
};

// Get QGenda Tasks And Schedules Service
export const getQgendaTasksAndSchedulesService = (payload) => {
    return post('Qgenda/GetQgendaTasksAndSchedules', payload);
};

